var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.707 12.293a1.001 1.001 0 010 1.415l-7 7a1.001 1.001 0 01-1.415 0l-3-3a1 1 0 011.415-1.415L14 18.585l6.293-6.293a1.001 1.001 0 011.415 0zM29 16A13 13 0 1116 3a13.014 13.014 0 0113 13zm-2 0a11 11 0 10-11 11 11.012 11.012 0 0011-11z"
  })));
}
export default SvgCheckCircleRegular;